// Lightweight free image search using Pexels and Unsplash (no server).
// Provide your API keys via environment or localStorage.

const getKey = (name) => {
    try {
        return (typeof window !== 'undefined' && window.localStorage && localStorage.getItem(name)) || import.meta?.env?.[name] || process?.env?.[name] || '';
    } catch (_) {
        return '';
    }
};

async function pexelsSearch(query, page = 1, perPage = 12) {
    const key = getKey('VITE_PEXELS_API_KEY');
    if (!key) return [];
    const resp = await fetch(`https://api.pexels.com/v1/search?query=${encodeURIComponent(query)}&page=${page}&per_page=${perPage}`, {
        headers: { Authorization: key },
    });
    if (!resp.ok) return [];
    const data = await resp.json();
    return (data.photos || []).map((p) => ({
        id: `pexels_${p.id}`,
        thumb: p.src.medium,
        full: p.src.large2x || p.src.large,
        author: p.photographer,
        url: p.url,
        source: 'pexels',
    }));
}

async function unsplashSearch(query, page = 1, perPage = 12) {
    const key = getKey('VITE_UNSPLASH_ACCESS_KEY');
    if (!key) return [];
    const resp = await fetch(`https://api.unsplash.com/search/photos?query=${encodeURIComponent(query)}&page=${page}&per_page=${perPage}&content_filter=high`, {
        headers: { Authorization: `Client-ID ${key}` },
    });
    if (!resp.ok) return [];
    const data = await resp.json();
    return (data.results || []).map((p) => ({
        id: `unsplash_${p.id}`,
        thumb: p.urls.small,
        full: p.urls.full || p.urls.regular,
        author: p.user?.name,
        url: p.links?.html,
        source: 'unsplash',
    }));
}

export async function searchImages(query, page = 1, perPage = 12) {
    const [a, b] = await Promise.allSettled([
        pexelsSearch(query, page, perPage),
        unsplashSearch(query, page, perPage),
    ]);
    const results = [];
    if (a.status === 'fulfilled') results.push(...a.value);
    if (b.status === 'fulfilled') results.push(...b.value);
    return results;
}

export default { searchImages };


